import { render, staticRenderFns } from "./ArticlesByTag.vue?vue&type=template&id=1402eb83&"
import script from "./ArticlesByTag.vue?vue&type=script&lang=js&"
export * from "./ArticlesByTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports